export default "__VITE_ASSET__I_uBe4ph__"